export default "__VITE_ASSET__8a36d844__$_?react__"